export default __webpack_public_path__ + "static/surfing-on-a-cloud-29c30167683510a9b31fb4186f3fb8d0.png";